import { TransferFundOptions } from '../../pages';
import { useStores, walletStore } from '../../stores';
import React, { useState } from 'react';

const TransferFundOptionContainer = ({
	closeTransferModal,
	transferSwitchState,
	bankListContent,
	setBankListContent,
	beneficiaryContent,
	setBeneficiaryContent,
	stage2,
	setStage2,
	setShowSurvey,
}) => {
	const [savedActive, setSavedActive] = useState(true);
	const [newActive, setNewActive] = useState(false);

	const [
		newBeneficiarySelectedState,
		setNewBeneficiarySelectedState,
	] = useState({
		key: '',
		value: '-Select-',
	});

	const [
		savedBeneficiarySelectedState,
		setSavedBeneficiarySelectedState,
	] = useState({
		key: '',
		data: {},
		value: '-Select-',
	});

	const {
		appStore: { beneficiaries, banks },
	} = useStores();

	const goToSaved = () => {
		setSavedActive(true);
		setNewActive(false);
	};

	const goToBankList = () => {
		setBankListContent(true);
	};

	const goToNew = () => {
		setSavedActive(false);
		setNewActive(true);
	};

	const beneficiaryList = () => {
		setBeneficiaryContent(true);
	};

	const onSelectBeneficiary = selectedBeneficiary => {
		const { accountName, accountNumber, bankName } = selectedBeneficiary.value;
		selectedBeneficiary = {
			key: selectedBeneficiary.key,
			data: selectedBeneficiary.value,
			value: `${accountName}-${accountNumber}\n${bankName}`,
		};
		setSavedBeneficiarySelectedState(selectedBeneficiary);
		setSavedActive(true);
		setNewActive(false);
		setBeneficiaryContent(false);
	};

	const onSelectBank = selectedBank => {
		setNewBeneficiarySelectedState(selectedBank);
		setBankListContent(false);
		setNewActive(true);
		setSavedActive(false);
	};

	const closeModal = () => {
		walletStore.setSelectedSubWallet({});
		closeTransferModal();
		setBankListContent(false);
	};

	return (
		<TransferFundOptions
			key="transferFundOptionModal"
			goToSaved={goToSaved}
			goToNew={goToNew}
			beneficiaryContent={beneficiaryContent}
			onSelectBank={onSelectBank}
			bankListContent={bankListContent}
			goToBankList={goToBankList}
			beneficiaryList={beneficiaryList}
			onSelectBeneficiary={onSelectBeneficiary}
			transferSwitchState={transferSwitchState}
			closeTransferModal={closeModal}
			savedActive={savedActive}
			newActive={newActive}
			beneficiaries={beneficiaries}
			banks={banks}
			savedBeneficiarySelectedState={savedBeneficiarySelectedState}
			newBeneficiarySelectedState={newBeneficiarySelectedState}
			stage2={stage2}
			setStage2={setStage2}
			setShowSurvey={setShowSurvey}
		/>
	);
};

export default TransferFundOptionContainer;
